import * as React from 'react';
import { Form, Input, SemanticWIDTHS } from 'semantic-ui-react';

export interface Datos {
    pendiente: boolean;
    fechaCompromiso: string;
}

export const inicial: Datos = {
    pendiente: false,
    fechaCompromiso: '',
};

interface Props {
    datos: Datos;
    ancho?: SemanticWIDTHS;
    onChange(datos: Datos): void;
}

const Pendiente: React.FunctionComponent<Props> = props => {
    const { datos, ancho, onChange } = props;

    return (
        <>
            <Form.Checkbox
                label='Pendiente'
                checked={datos.pendiente}
                onChange={(_e, { checked }) => {
                    onChange({ ...datos, pendiente: checked || false });
                }}
            />

            <Form.Field
                hidden={!datos.pendiente}
                required={datos.pendiente}
                error={datos.pendiente && datos.fechaCompromiso.length === 0}
                width={ancho}
            >
                <label>Fecha de compromiso</label>
                <Input
                    type='date'
                    required={datos.pendiente}
                    value={datos.fechaCompromiso}
                    onChange={(_e, { value }) => {
                        onChange({ ...datos, fechaCompromiso: value || '' });
                    }}
                />
            </Form.Field>
        </>
    );
};

export default Pendiente;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/Pendiente.tsx